// extracted by mini-css-extract-plugin
export default {"root":"_2qKF4","label":"_2Lw_m"};